import Button from 'components/partials/Fields/Button';

export const ChooseType = ({ onSubmit, phone, disabled }) => {

    const handleTextButtonClick = () => {
        onSubmit('text');
    };

    return (
        <>
            <div className="row">
                <div className="col text-center">
                    <p>
                        For your security, we ask that you confirm your
                        identity providing a verification code sent to you.
                        <br/>
                        You will receive a 6-digit code to input on
                        StorageTreasures.com website that helps us confirm
                        your identity and keep your data safe.
                        <br/>
                        <br/>
                        Verification code will be sent to phone number ending
                        in {phone.substring(phone.length - 4, phone.length)}
                        <br/>
                        <br/>
                        How would you like to receive the code?
                    </p>
                </div>
            </div>
            <div className="row w-100">
                <div className="col-sm marginT15 button-container">
                    <Button
                        disabled={disabled}
                        variant="primary"
                        label="Text"
                        onClick={handleTextButtonClick}
                    />
                </div>
                <div className="col-sm marginT15 button-container">
                    <Button
                        disabled={disabled}
                        variant="primary"
                        label="Call"
                        onClick={() => onSubmit('voice')}
                    />
                </div>
            </div>
            <div className="row marginT35">
                <div className="col">
                    <span><strong>Note:</strong> Messages and Data rates may apply.</span>
                </div>
            </div>
        </>
    );
};
